var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.01 189.07",
    fill: "#4d4d4d",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.88,66.43c5.38,4.09,11.46-.9,15.67,3.24,4.6,4.52-.66,12.44-1.94,30.3-.59,8.32.12,15.39,1.56,29.53,1.08,10.72,2,14.29,3.36,28,1.31,13.2,1.93,19.86.52,22.4-5,8.95-19.52,9.16-46.88,9.19-27.08,0-40.74-.1-45.84-8.54-2.52-4.18-1.51-12,.52-27.58C4.65,139.05,6.22,137.73,7,127a141.8,141.8,0,0,0-.64-25.51c-2.13-20-4.93-25.57-.89-30.1,4.9-5.5,12.42-.56,17.72-6s.42-12.53,1.47-31.86C25.28,22,25.85,13.77,32,7.64,32.93,6.69,39.33.5,48.56,1A21.37,21.37,0,0,1,60.73,6C63,7.82,68.51,13.1,71.16,33.14,73.83,53.43,70,62,75.88,66.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadow);
export default __webpack_public_path__ + "static/media/shadow.2d5754e7a13850ab416ead5df4cfd05c.svg";
export { ForwardRef as ReactComponent };